/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IRdaCustomHtmlData } from './rda-custom-html.data';
import { IRdaCustomHtmlProps } from './rda-custom-html.props.autogenerated';
import { IModule } from '@msdyn365-commerce/core';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';

export interface IRdaCustomHtmlViewProps extends IRdaCustomHtmlProps<IRdaCustomHtmlData> {
    moduleProps: IModule;
    className?: string;
    RdaCustomHtml: IModuleProps;
    product: any;
}

/**
 *
 * RdaCustomHtml component
 * @extends {React.PureComponent<IRdaCustomHtmlProps<IRdaCustomHtmlData>>}
 */
class RdaCustomHtml extends React.PureComponent<IRdaCustomHtmlProps<IRdaCustomHtmlData>> {
    public render(): JSX.Element | null {
        const {
            data: {
                product: { result: product }
            },
            config: { className = '' }
        } = this.props;
        const viewProps: IRdaCustomHtmlViewProps = {
            moduleProps: { ...this.props },
            ...this.props,
            ...this.state,
            product: product,
            RdaCustomHtml: {
                moduleProps: this.props,
                className: className
            }
        };
        return this.props.renderView(viewProps);
    }
}

export default RdaCustomHtml;
